/*
 * @author Dallas Yan (@dallasyan)
 */
import { useEffect, useState } from "react";
import entryTestClient from "../client/EntryTestClient";
export const useSubjects = (): string[] | undefined => {
    const [subjects, setSubjects] = useState<string[]>();

    useEffect(() => {
        const fetchData = async () => {
            setSubjects(await entryTestClient.getSubjectNames());
        };
        fetchData().catch(console.error);
    }, []);

    return subjects;
};
